import {defineStore} from 'pinia';
import backendCall from "../services/AxiosService";


export const useRequestsStore = defineStore('requests', {
    state: () => ({
        requests: [],
        requestCount: null as number | null,
        unsentRequestCount: null as number | null,
        deferredRequestCount: null as number | null
    }), actions: {
        async fetchRequests() {
            try {
                const response = await backendCall.get('requests');

                if (response.data && response.data.data) {
                    const requestResponse = response.data.data;
                    this.requests = requestResponse;
                    this.requestCount = requestResponse.length;
                } else {
                    this.requests = [];
                    this.requestCount = 0;
                }
            } catch (error) {
                console.error('There was a problem fetching requests:', error);
                this.requests = [];
                this.requestCount = 0;
            }
        },

        async fetchUnsentRequestCount() {
            try {
                const response = await backendCall.get('requests', {
                    params: { filter: 'submitted_but_not_sent' }
                });
                if (response.data?.success) {
                    this.unsentRequestCount = response.data.data?.length ?? 0;
                }
            } catch (error) {
                console.error('Error fetching unsent request count:', error);
                this.unsentRequestCount = 0;
            }
        },

        async fetchDeferredRequestCount() {
            try {
                const response = await backendCall.get('requests/info-deferred');
                if (response.data?.success) {
                    this.deferredRequestCount = response.data.data?.length ?? 0;
                }
            } catch (error) {
                console.error('Error fetching deferred request count:', error);
                this.deferredRequestCount = 0;
            }
        }
    },

});
